import { reduxForm } from "redux-form";

const toRenderProp = ({ children, ...rest }) => children(rest);
// function that takes configuration object and returns a new function; use it to wrap your form component and bind user interaction to dispatch of Redux actions
export default reduxForm({
})(toRenderProp);